import * as React from "react";
import * as moment from "moment";
import { connect } from "react-redux";

import Money from "web_modules/Money";
import Spinner from "web_modules/shared/Spinner";
import { formatPhoneNumber } from "@eave/shared/utils/phone";

import { convertTimeFrame } from "./helpers";
import { loadSearchData } from "web_modules/redux/searchPreApprovals/actions";

const styles = require("./styles.module.scss");

interface PreApprovalsProps {
  preApprovals: any[];
  dispatch?: Function;
}

class PreApprovals extends React.Component<PreApprovalsProps, any> {
  componentDidMount() {
    this.props.dispatch(loadSearchData());
  }

  render() {
    const { preApprovals } = this.props;

    if (!preApprovals.length) {
      return (
        <div className={styles.homepage}>
          <h1>Pre-Approval Applications</h1>
          <Spinner active />
        </div>
      );
    }

    return (
      <div className={styles.homepage}>
        <h1>Pre-Approval Applications</h1>
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th scope="col">ID</th>
              <th scope="col">Full Name</th>
              <th scope="col">Email</th>
              <th scope="col">Phone Number</th>
              <th scope="col">Target Timeframe</th>
              <th scope="col">Credit Score</th>
              <th scope="col">Target Purchase Price</th>
              <th scope="col">Target Loan Amount</th>
              <th scope="col">Pre-Approval Started</th>
            </tr>
          </thead>
          <tbody>
            {preApprovals.map(pa => (
              <tr key={pa.id}>
                <td>{pa.id}</td>
                <td>
                  <a href={`/loan-officer/pre-approvals/${pa.id}`}>
                    {`${pa.borrower1_first_name} ${pa.borrower1_last_name}`}
                  </a>
                </td>
                <td>{pa.borrower1_email}</td>
                <td>{formatPhoneNumber(pa.borrower1_phone)}</td>
                <td>{convertTimeFrame(pa.purchase_timeframe)}</td>
                <td>{pa.credit_score}</td>
                <td>
                  <Money value={pa.borrower_estimated_purchase_price} />
                </td>
                <td>
                  <Money value={pa.borrower_estimated_loan_amount} />
                </td>
                <td>{moment(pa.created_at).format("MMM D, Y")}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const preApprovals = state.preApprovals.searchData;
  return {
    preApprovals,
  };
};

export default connect<any, any, any>(mapStateToProps)(PreApprovals);
